// extracted by mini-css-extract-plugin
module.exports = {"products":"zx-z","misad":"Ax-z","oosMessaging":"Bx-z","productCardOverrides":"Cx-z","secondRowAds":"Dx-z","microsoftAdsWrapper":"Ex-z"};